import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ChecklistRespostaForm from '../checklistResposta/checklistRespostaForm';

import {
	setModoTela, initForm, gerarPdf, salvarCheklistStatus, atualizarObjeto
} from './relatorioActions';

import { setModoTela as setModoTelaChecklist, initForm as initFormChecklist, continuarChecklist, excluir as excluirChecklist } from '../checklistResposta/checklistRespostaActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import ImagemZoom from '../common/imagemZoom/ImagemZoom';
import consts from '../consts';

class RelatorioForm extends Component {

	state = {

	}

    componentWillMount() {
		this.props.setModoTelaChecklist('lista');
    }

    render() {

		if (this.props.modoTelaChecklist == 'cadastro') {
			return ((
				<ChecklistRespostaForm />
			));
		}

		let readOnly = this.props.formularioValues.id || this.props.excluir ? 'readOnly' : '';

		let modelo = this.props.listaModeloRelatorio.filter(item => item.id == this.props.formularioValues.id_modelo_relatorio)[0];

		let paginas = [];
		let pagina = {
			numero: 1,
			html: '',
			tamanho: 0
		};

		let adicionarNaPagina = (item, tamanho) => {
			if (pagina.tamanho + tamanho > 700) {
				paginas.push({ ...pagina });

				pagina = {
					numero: pagina.numero + 1,
					html: '',
					tamanho: 0
				};
			}

			pagina = {
				...pagina,
				html: `
					${pagina.html}
					${item}
				`,
				tamanho: pagina.tamanho + tamanho
			};

		}

		adicionarNaPagina(`<p style="font-size: 8px;">_______________________________________________________________________________________________________________________________________</p>`, 35);

		adicionarNaPagina(`<p style="font-size: 10px; margin: 0px; padding: 0px;"><b>Cliente:</b> ${this.props.formularioValues.nome_cliente}</p>`, 35);
		if (this.props.formularioValues.nome_grupo) {
			adicionarNaPagina(`<p style="font-size: 10px; margin: 0px; padding: 0px;"><b>Grupo:</b> ${this.props.formularioValues.nome_grupo}</p>`, 35);			
		}
		if (this.props.formularioValues.nome_cidade) {
			adicionarNaPagina(`<p style="font-size: 10px; margin: 0px; padding: 0px;"><b>Cidade:</b> ${this.props.formularioValues.nome_cidade} - ${this.props.formularioValues.nome_estado}</p>`, 35);
		}

		adicionarNaPagina(`<p style="font-size: 8px; padding-top: 0px; margin-top: 0px;">_______________________________________________________________________________________________________________________________________</p>`, 45);

		let numeroCapitulo = 0;
		let numeroSubArea = 0;
		let numeroImagem = 0;

		this.props.listaEstrutura.forEach(estrutura => {

			estrutura.listaArea.forEach((area, i) => {

				const existeResposta = estrutura.listaPergunta.filter(pergunta => pergunta.id_area == area.id).filter(pergunta => {
					return estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id).length;
				}).filter((pergunta, j) => {
					
					let resposta = estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id)[0];
					
					let respostaPai = (this.state.checklistResposta ? this.state.checklistResposta.itens : []).filter(itemResposta => itemResposta.id_item == pergunta.id_pai)[0];
												
					if (pergunta.id_pai && (!respostaPai || pergunta.pai_condicao != respostaPai.resposta)) {
						return null;
					}

					return resposta.imprime_relatorio
						&& (
							resposta.resposta
							|| pergunta.imagem //Se tem imagem na pergunta mostra - pois essa pergunta não tem resposta
							|| (resposta.complemento_comentario || '').trim()
							|| (resposta.complemento_foto || []).length
							|| (resposta.complemento_fotos || []).length
							|| (resposta.complemento_registro_fotos || []).length
							|| (resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura).length
							|| estrutura.listaArea.filter(areaFilho => areaFilho.id_pai == area.id).length
						);
				}).length;

				if (!existeResposta) {
					return;
				}

				if (!area.id_pai) {
					numeroCapitulo++;
					numeroSubArea = 0;
				} else {
					numeroSubArea++;
				}

				adicionarNaPagina(`<p style="font-size: 12px; font-weight: bold;${numeroSubArea ? ' font-style: italic;' : ''} ${numeroSubArea ? '' : 'text-align: center;'}">${numeroCapitulo}.${numeroSubArea ? `${numeroSubArea}.` : ''} ${area.nome}</p>`, 45);

				estrutura.listaPergunta.filter(pergunta => pergunta.id_area == area.id).filter(pergunta => {
					return estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id).length;
				}).map((pergunta, j) => {
					
					let resposta = estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id)[0];

					let tamanho = 0;

					let respostaDescricao = '';
					if (resposta) {
						if (pergunta.id_tipo == 1 && resposta.resposta) { //Texto Curto
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${resposta.resposta || ''}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 2 && resposta.resposta) { //Texto Longo
							respostaDescricao = (resposta.resposta || '').split('\n').map(respostaItem => `<p style="padding: 0px; text-align: justify; text-indent: 2em;">${respostaItem}</p>`).join('\n');
							tamanho += (resposta.resposta || '').split('\n').length * 45;
						} else if (pergunta.id_tipo == 3 && resposta.resposta) { //Data
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${DateFormat.formatarDataSqlParaTela(resposta.resposta)}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 4 && resposta.resposta) { //Numérica
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${resposta.resposta || ''}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 5 && resposta.resposta) { //Lista de Seleção Única
							let opcaoSelecionada = (pergunta.opcoes || []).filter(opcao => opcao.id == resposta.resposta)[0];
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${opcaoSelecionada ? opcaoSelecionada.nome : ''}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 6 && resposta.resposta) { //Lista de Seleção Múltipla
							respostaDescricao = `${(resposta.resposta || []).map(respostaOpcao => {
								let opcaoSelecionada = (pergunta.opcoes || []).filter(opcao => opcao.id == respostaOpcao)[0];
								return `<p style="text-align: justify; text-indent: 2em;">${opcaoSelecionada ? opcaoSelecionada.nome : null}</p>`;
							}).filter(respostaOpcao => respostaOpcao).join('\n')}`;
							tamanho += 45 * (resposta.resposta || []).length;
						} else if (pergunta.id_tipo == 7 && resposta.resposta) { //Avaliativa
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${resposta.resposta || ''}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 9 && resposta.resposta) { //Pergunta com Dependentes
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${
								resposta.resposta ? (
									resposta.resposta == 'Sim' ? (pergunta.dependente_condicao_1 || 'Sim') : (pergunta.dependente_condicao_2 || 'Não')
								) : ''
							}</p>`;
							tamanho += 45;
						} else if (pergunta.id_tipo == 10 && resposta.resposta) { //Hora
							respostaDescricao = `<p style="text-align: justify; text-indent: 2em;">${resposta.resposta || ''}</p>`;
							tamanho += 45;
						}
					}

					if (resposta.complemento_comentario) {
						tamanho += (resposta.complemento_comentario || '').split('\n').length * 45;
					}

					if (resposta.complemento_foto) {
						tamanho += 220;
					}
					// if ((resposta.complemento_fotos || []).length) {
					// 	tamanho += 220 * (resposta.complemento_fotos || []).length;
					// }
					
					let assinaturas = (resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura);

					if (assinaturas.length > 0) {
						tamanho += 40;
					}

					if (resposta.imprime_relatorio
						&& (
							respostaDescricao 
							|| (resposta.complemento_fotos || []).length 
							|| (resposta.complemento_registro_fotos || []).length 
							|| resposta.complemento_comentario 
							|| assinaturas.length
						)
					) {
						adicionarNaPagina(`
							<p style="font-size: 11px; font-weight: bold; margin-left: 12px; ">${numeroCapitulo}.${numeroSubArea ? `${numeroSubArea}.` : ''}${j+1} ${pergunta.descricao}</p>
							<div style="margin-left: 28">
								<div style="font-size: 10px; padding-left: 14px;">
									${respostaDescricao}
															
									${resposta.complemento_comentario ? `
										<p style="font-weight: bold; font-style: italic; padding: 0px;">Comentário:</p>
										${(resposta.complemento_comentario || '').split('\n').map(comentario => `<p style="font-style: 'italic'; padding: 0px; text-align: justify; text-indent: 2em;">${comentario}</p>`).join('\n')}
									` : ''}
								</div>
							
								${resposta.complemento_foto ? `
									<div style="margin-bottom: 8px;">
										<img src="${resposta.complemento_foto}" style="height: 200px" />
									</div>
								` : ''}

								${assinaturas.length > 0 
									? `
										<table style="width: 100%; margin-bottom: 8px; margin-top: 8px;">
											<tbody>
												<tr>
													${assinaturas.map(assinatura => `
														<td colspan="2" style="text-align: center;">
															<img src="${assinatura.assinatura}" style="height: 20px" />
														</td>
													`).join('\n')}
												</tr>
												<tr>
													${assinaturas.map(assinatura => `
													<td style="text-align: center; font-size: 6px;">
														${assinatura.nome} | ${assinatura.cargo}
													</td>
													`).join('\n')}
												</tr>
											</tbody>
										</table>									`
									: ''
								}
							</div>
						`, tamanho);
					
						for (let posImg = 0; posImg < (resposta.complemento_fotos || []).length; posImg += 2) {
							const foto1 = (resposta.complemento_fotos || [])[posImg];
							const foto2 = (resposta.complemento_fotos || [])[posImg + 1];
							adicionarNaPagina(`
								<div style="width: 550px; margin-bottom: 8px; text-align: center;">
									<table style="width: 100%; height: 200px;" >
										<tbody>
											<tr>
												<td width=100>
													<img src="${foto1}" style="max-height: 200px; max-width: 260px; height: auto; width: auto;" />
													<p style="padding: 0; margin: 0; font-style: italic; font-size: 8px;">Legenda da Imagem</p>
												</td>
												${foto2 ? `
												<td width=100>
													<img src="${foto2}" style="max-height: 200px; max-width: 260px; height: auto; width: auto;" />
													<p style="padding: 0; margin: 0; font-style: italic; font-size: 8px;">Legenda da Imagem</p>
												</td>` : ''}
											</tr>
										</tbody>
									</table>
								</div>
							`, 220);
						}

						for (let posImg = 0; posImg < (resposta.complemento_registro_fotos || []).filter(foto => foto && foto.base64).length; posImg += 2) {
							const foto1 = (resposta.complemento_registro_fotos || []).filter(foto => foto && foto.base64)[posImg];
							const foto2 = (resposta.complemento_registro_fotos || []).filter(foto => foto && foto.base64)[posImg + 1];
							adicionarNaPagina(`
								<div style="width: 550px; margin-bottom: 8px; text-align: center;">
									<table style="width: 100%; height: 200px;">
										<tbody>
											<tr>
												<td width=100>
													<img src="${foto1.base64}" style="max-height: 200px; max-width: 260px; height: auto; width: auto;" />
													<p style="padding: 0; margin: 0; font-style: italic; font-size: 8px;">${foto1.legenda || 'Sem legenda'}</p>
												</td>
												${foto2 ? `
												<td width=100>
													<img src="${foto2.base64}" style="max-height: 200px; max-width: 260px; height: auto; width: auto;" />
													<p style="padding: 0; margin: 0; font-style: italic; font-size: 8px;">${foto2.legenda || 'Sem legenda'}</p>
												</td>` : ''}
											</tr>
										</tbody>
									</table>
								</div>
							`, 220);
						}
					}

				});
			});
		});

		paginas.push({ ...pagina });

		let registro = {
			imagem_capa: modelo ? modelo.imagem_capa : null,
			imagem_cabecalho: modelo ? modelo.imagem_cabecalho : null,
			imagem_rodape: modelo ? modelo.imagem_rodape : null,
			imagem_folha_contatos: modelo ? modelo.imagem_folha_contatos : null,
			paginas: paginas
		};

		numeroCapitulo = 0;
		numeroSubArea = 0;

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						{!this.props.visualizar &&
						<Row>
							{(this.props.formularioValues.listaOutros && this.props.formularioValues.listaOutros.length > 0) && 
							<Select
								name='checklist_respostas'
								label='Checklists' placeholder='Informe'
								options={this.props.formularioValues.listaOutros.map(item => ({
									id: item.id,
									valor: `${item.nome_checklist} - ${item.nome_usuario} (${DateFormat.formatarDataSqlParaTela(item.data_agendamento || item.datahora_inclusao)})`
								}))}
								multiple
								cols='12 12 12 12'
								readOnly={readOnly}
								value={(this.props.formularioValues.checklist_respostas || [])}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										checklist_respostas: (value || []).map(item => parseInt(item.value))
									});
								}} />}

							<Field
								name='nome_checklist'
								component={LabelAndInput}
								label='Checklist' placeholder='Informe o nome'
								cols='12 6 6 6'
								readOnly={readOnly} />

							<Field
								name='id_modelo_relatorio'
								component={Select}
								options={this.props.listaModeloRelatorio}
								label='Modelo'
								cols='12 6 6 6'
								placeholder='Selecione'
								readOnly={readOnly} />
															
						</Row>}

						{this.props.listaEstrutura.map(estrutura => (
							
							<div
								style={{
									height: window.innerWidth > 576 ? window.innerHeight - 240 : null,
									overflowY: window.innerWidth > 576 ? 'auto' : null,
								}}>

								{estrutura.listaArea.map((area, i) => {

									const existeResposta = estrutura.listaPergunta.filter(pergunta => pergunta.id_area == area.id).filter(pergunta => {
										return estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id).length;
									}).filter((pergunta, j) => {
										
										let resposta = estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id)[0];

										return resposta.imprime_relatorio
											&& (
												resposta.resposta
												|| pergunta.imagem //Se tem imagem na pergunta mostra - pois essa pergunta não tem resposta
												|| (resposta.complemento_comentario || '').trim()
												|| (resposta.complemento_foto || []).length
												|| (resposta.complemento_fotos || []).length
												|| (resposta.complemento_registro_fotos || []).length
												|| (resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura).length
												|| estrutura.listaArea.filter(areaFilho => areaFilho.id_pai == area.id).length
											);
									}).length;

									if (!existeResposta) {
										return;
									}

									if (!area.id_pai) {
										numeroCapitulo++;
										numeroSubArea = 0;
									} else {
										numeroSubArea++;
									}

									return (
										<Row>

											<Grid cols='12 12 12 12'>
												<p style={{ fontSize: 16, fontWeight: 'bold', fontStyle: numeroSubArea ? 'italic' : null }}>{numeroCapitulo}.{numeroSubArea ? `${numeroSubArea}.` : ''} {area.nome}</p>
											</Grid>

											{estrutura.listaPergunta.filter(pergunta => pergunta.id_area == area.id).filter(pergunta => {
												return estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id).length;
											}).map((pergunta, j) => {
												
												let resposta = estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id)[0];

												let respostaPai = estrutura.listaRespostaItem.filter(itemResposta => itemResposta.id_item == pergunta.id_pai)[0];

												if (pergunta.id_pai && (!respostaPai || pergunta.pai_condicao != respostaPai.resposta)) {
													return null;
												}

												let respostaDescricao = () => '';
												if (resposta) {
													if (false && pergunta.imagem) { //Se tem imagem na pergunta mostra - pois essa pergunta não tem resposta
													} else if (pergunta.id_tipo == 1 && resposta.resposta) { //Texto Curto
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{resposta.resposta}</p>;
													} else if (pergunta.id_tipo == 2 && resposta.resposta) { //Texto Longo
														respostaDescricao = () => (resposta.resposta || '').split('\n').map(respostaItem => <p style={{ padding: 0, textAlign: 'justify', textIndent: '2em' }}>{respostaItem}</p>);
													} else if (pergunta.id_tipo == 3 && resposta.resposta) { //Data
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{DateFormat.formatarDataSqlParaTela(resposta.resposta)}</p>;
													} else if (pergunta.id_tipo == 4 && resposta.resposta) { //Numérica
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{resposta.resposta}</p>;
													} else if (pergunta.id_tipo == 5 && resposta.resposta) { //Lista de Seleção Única
														let opcaoSelecionada = (pergunta.opcoes || []).filter(opcao => opcao.id == resposta.resposta)[0];
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{opcaoSelecionada ? opcaoSelecionada.nome : null}</p>;
													} else if (pergunta.id_tipo == 6 && resposta.resposta) { //Lista de Seleção Múltipla
														respostaDescricao = () => (resposta.resposta || []).filter(respostaOpcao => respostaOpcao).map(respostaOpcao => {
															let opcaoSelecionada = (pergunta.opcoes || []).filter(opcao => opcao.id == respostaOpcao)[0];
															return <p style={{ textAlign: 'justify', textIndent: '2em' }}>{opcaoSelecionada ? opcaoSelecionada.nome : null}</p>;
														});
													} else if (pergunta.id_tipo == 7 && resposta.resposta) { //Avaliativa
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{resposta.resposta}</p>;
													} else if (pergunta.id_tipo == 9 && resposta.resposta) { //Pergunta com Dependente
														respostaDescricao = () => 
															<p style={{ textAlign: 'justify', textIndent: '2em' }}>{
																resposta.resposta ? (
																	resposta.resposta == 'Sim' ? (pergunta.dependente_condicao_1 || 'Sim') : (pergunta.dependente_condicao_2 || 'Não')
																) : ''
															}</p>;
													} else if (pergunta.id_tipo == 10 && resposta.resposta) { //Hora
														respostaDescricao = () => <p style={{ textAlign: 'justify', textIndent: '2em' }}>{resposta.resposta}</p>;
													}
												}
												if (resposta.imprime_relatorio
													&& (
														respostaDescricao() 
														|| pergunta.imagem //Se tem imagem na pergunta mostra - pois essa pergunta não tem resposta
														|| (resposta.complemento_fotos || []).length 
														|| (resposta.complemento_registro_fotos || []).length
														|| resposta.complemento_comentario
														|| (resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura).length
													)
												) {

													return (
														<Grid cols='12 12 12 12'>
															<p style={{ fontSize: 14, fontWeight: 'bold', marginLeft: 12 }}>{numeroCapitulo}.{numeroSubArea ? `${numeroSubArea}.` : ''}{j+1} {pergunta.descricao}</p>
															<div style={{ marginLeft: 28}}>

																{pergunta.imagem &&
																<Row>
																	<Grid cols='12 12 12 12'>
																		<div
																			style={{
																				display: 'flex',
																				flexDirection: 'row',
																				alignItems: 'center',
																				marginBottom: 12,
																				marginTop: 12,
																				marginLeft: 8,
																				marginRight: 8
																			}}>
																			<span class="btn btn-outline-secondary fileinput-button dz-clickable">
																				<img src={`${consts.URL}/${pergunta.imagem}`}
																					style={{
																						width: '100%',
																						maxWidth: 800,
																						maxHeight: 800
																					}} />
																			</span>
																		</div>
																	</Grid>
																</Row>}

																{respostaDescricao()}

																{(resposta && resposta.complemento_comentario) &&
																<>
																	<p style={{ fontWeight: 'bold', fontStyle: 'italic', padding: 0 }}>Comentário:</p>
																	{(resposta.complemento_comentario || '').split('\n').map(comentario => <p style={{ fontStyle: 'italic', padding: 0, textAlign: 'justify', textIndent: '2em' }}>{comentario}</p>)}
																</>}

																{resposta.complemento_foto && 
																<div style={{ marginBottom: 8 }}>
																	<img src={resposta.complemento_foto} style={{ height: 450 }} />
																</div>}

																{(resposta.complemento_fotos || []).map(foto =>
																	<div style={{ marginBottom: 8 }}>
																		<img src={foto} style={{ height: 450 }} />
																	</div>
																)}

																{(resposta.complemento_registro_fotos || []).filter(foto => foto).map((foto, posImg) =>
																	<div style={{ marginBottom: 8, textAlign: 'center' }}>
																		{/*<img src={foto.base64} style={{ maxHeight: 400, maxWidth: 600, height: 'auto', width: 'auto' }} />*/}
																		<ImagemZoom src={foto.base64} alt='' />
																		<a style={{ paddingTop: 8 }}
																			href={`${consts.OAPI_URL}/imagem?id=${Buffer.from(`${resposta.id},${posImg}`).toString('base64')}`}
																			target='blank'>
																			Imagem {++numeroImagem}
																		</a>{foto.legenda ? ` - ${foto.legenda}` : ''}
																	</div>
																)}

																{(resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura).length > 0 &&
																<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
																	{(resposta.complemento_assinatura || []).filter(assinatura => assinatura && assinatura.assinatura).map(assinatura =>
																		<div style={{ marginBottom: 8 }}>
																			<img src={assinatura.assinatura} style={{ height: 40 }} />
																			<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
																				<div style={{ fontSize: 9, textAlign: 'center' }}>{assinatura.nome} | {assinatura.cargo}</div>
																			</div>
																		</div>
																	)}														
																</div>}
															</div>
														</Grid>
													);
												} else {
													return null;
												}

											})}

										</Row>
									);
								})}
							</div>
						))}

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>

							{(this.props.formularioValues.modoRejeitar || this.props.formularioValues.modoFinalizar) && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Editar'
									type={'primary'}
									icon={'fa fa-chevron-left'}
									event={() => {
										
										if (window.confirm('Deseja realmente editar?')) {
											this.props.continuarChecklist(
												{ 
													...this.props.formularioValues.checklist_resposta_objeto,
													edicaoRelatorio: true,
													eventoAtualizarRelatorio: () => {
														this.props.atualizarObjeto({ ...this.props.formularioValues });
													}
												}, 
												(checklistResposta) => {
													this.props.initFormChecklist({ ...checklistResposta });
													this.props.setModoTelaChecklist('cadastro', { ...checklistResposta });
												}
											);
										}
									}} />
							</Grid>}

							{(this.props.formularioValues.modoRejeitar || this.props.formularioValues.modoFinalizar) && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Excluir'
									type={'danger'}
									icon={'fa fa-chevron-left'}
									event={() => {
										
										if (window.confirm('Deseja realmente excluir?')) {
											this.props.excluirChecklist({ 
												...this.props.formularioValues.checklist_resposta_objeto
											});
											this.props.setModoTela('lista')
										}
									}} />
							</Grid>}

							{this.props.formularioValues.modoRejeitar && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Rejeitar'
									type={'danger'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente rejeitar?') ? this.props.salvarCheklistStatus({
										...this.props.formularioValues.checklist_resposta_objeto,
										id_status: 2 //Em andamento
									}) : null} />
							</Grid>}

							{this.props.formularioValues.modoFinalizar && 
							<Grid cols='6 6 4 2'>
								<Button
									text='Finalizar'
									type={'success'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente finalizar?') ? this.props.salvarCheklistStatus({
										...this.props.formularioValues.checklist_resposta_objeto,
										id_status: 4 //Finalizar
									}) : null} />
							</Grid>}

							{!this.props.visualizar &&
							<Grid cols='6 6 4 2'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text={this.props.formularioValues.id ? 'OK' : 'Salvar'}
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>}
							{this.props.formularioValues.id &&
							<Grid cols='6 6 4 2'>
								<Button
									text={'Imprimir'}
									type={'primary'}
									icon={'fa fa-check'}
									event={() => this.props.gerarPdf({
										...this.props.formularioValues
									})} />
							</Grid>}
							<Grid cols='6 6 4 2'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

RelatorioForm = reduxForm({form: 'relatorioForm', destroyOnUnmount: false})(RelatorioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('relatorioForm')(state),
	registro: state.relatorio.registro,
	listaModeloRelatorio: state.relatorio.listaModeloRelatorio,
	listaEstrutura: state.relatorio.listaEstrutura,
	modoTelaChecklist: state.checklistResposta.modoTela
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, gerarPdf, salvarCheklistStatus,
	setModoTelaChecklist, initFormChecklist, continuarChecklist, excluirChecklist,
	atualizarObjeto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(RelatorioForm);
